import { useEffect, useState } from "react";

// Display-only countdown. The SERVER deadline is authoritative; this just renders
// remaining seconds from a server-provided deadline ISO string. Refreshing the
// page re-reads the same server deadline, so the clock cannot be reset by reload.
export function useCountdown(deadlineIso: string | null): number {
  const [remaining, setRemaining] = useState(() => calc(deadlineIso));
  useEffect(() => {
    setRemaining(calc(deadlineIso));
    if (!deadlineIso) return;
    const id = setInterval(() => setRemaining(calc(deadlineIso)), 200);
    return () => clearInterval(id);
  }, [deadlineIso]);
  return remaining;
}

function calc(deadlineIso: string | null): number {
  if (!deadlineIso) return 0;
  return Math.max(0, Math.ceil((new Date(deadlineIso).getTime() - Date.now()) / 1000));
}

export function QuestionTimer({ deadlineIso }: { deadlineIso: string | null }) {
  const s = useCountdown(deadlineIso);
  return <div className={`timer ${s <= 5 ? "warn" : ""}`}>{s}</div>;
}

// Human-friendly "9h 42m" remaining for a live drop window.
export function remainingWindow(closesAtIso: string | null): string {
  if (!closesAtIso) return "";
  const ms = new Date(closesAtIso).getTime() - Date.now();
  if (ms <= 0) return "0m";
  const h = Math.floor(ms / 3600000);
  const m = Math.floor((ms % 3600000) / 60000);
  return h > 0 ? `${h}h ${m}m` : `${m}m`;
}
